import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'LeadServed/role/autocomplete';

export function useLeadServedRoleAutocompleteQuery({
	fragment = '',
	pageSize = 50,
	enforcePageSize = true,
	enabled = true,
}: {
	fragment?: string;
	pageSize?: number;
	enforcePageSize?: boolean;
	enabled?: boolean;
} = {}) {
	const userSession = useUserSession();

	return useQuery({
		enabled,
		queryFn: async () => {
			const result = await userSession.webServiceHelper.callAsync<{ values: string[] }>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { enforcePageSize, fragment, pageSize },
					urlPath: BASE_QUERY_KEY,
				}),
				'GET'
			);
			return result.values || [];
		},
		queryKey: [BASE_QUERY_KEY, userSession.account?.id, fragment, pageSize, enforcePageSize],
		refetchOnWindowFocus: false,
		staleTime: 5 * 60 * 1000,
		meta: {
			errorLogging: { category: 'LeadServed', action: 'LeadServedRoleAutocompleteQuery-Error' },
			toastErrorMessage: 'Failed to load roles',
		},
	});
}
